import { Ref, useEffect, useImperativeHandle, useState } from "react";

export interface AnimatorHandle {
  play: () => void;
  pause: () => void;
}

export function useAnimator(
  ref: Ref<AnimatorHandle> | undefined,
  autoPlay: boolean,
) {
  const [paused, setPaused] = useState(!autoPlay);

  useEffect(() => {
    setPaused(!autoPlay);
  }, [autoPlay]);

  useImperativeHandle(
    ref,
    () => ({
      play: () => setPaused(false),
      pause: () => setPaused(true),
    }),
    [],
  );

  return {
    paused,
    play: () => setPaused(false),
    pause: () => setPaused(true),
  };
}
